module.exports = __webpack_public_path__ + "static/media/how_to_use_7.01b3c85e.png";